import { STEP_IDENTIFIER_NAME } from 'src/app/pages/startAPetition/pageContext';

import { AiAsksChoice, preloadAIAsksChoiceStep } from './components/AIAsksChoice';
import { AIDescription, preloadAIDescriptionStep } from './components/AIDescription';
import { AIPrompt, preloadAIPromptStep } from './components/AIPrompt';
import { AIResultsDraft, preloadAIResultsDraftStep } from './components/AIResultsDraft';
import { Ask, preloadAskStep } from './components/Ask';
import { Description, preloadDescriptionStep } from './components/Description';
import { Location, preloadLocationStep } from './components/Location';
import { Media, preloadMediaStep } from './components/Media';
import { PhoneCollection, preloadPhoneCollectionStep } from './components/PhoneCollection';
import { preloadPublishStep, Publish } from './components/Publish';
import { preloadReachStep, Reach } from './components/Reach';

export const STEP_MAP = {
	[STEP_IDENTIFIER_NAME.AI_ASK_CHOICE]: {
		component: AiAsksChoice,
		preload: preloadAIAsksChoiceStep,
	},
	[STEP_IDENTIFIER_NAME.AI_PROMPT]: {
		component: AIPrompt,
		preload: preloadAIPromptStep,
	},
	[STEP_IDENTIFIER_NAME.AI_DESCRIPTION]: {
		component: AIDescription,
		preload: preloadAIDescriptionStep,
	},
	[STEP_IDENTIFIER_NAME.AI_RESULTS_DRAFT]: {
		component: AIResultsDraft,
		preload: preloadAIResultsDraftStep,
	},
	[STEP_IDENTIFIER_NAME.ASK]: {
		component: Ask,
		preload: preloadAskStep,
	},
	[STEP_IDENTIFIER_NAME.DESCRIPTION]: {
		component: Description,
		preload: preloadDescriptionStep,
	},
	[STEP_IDENTIFIER_NAME.LOCATION]: {
		component: Location,
		preload: preloadLocationStep,
	},
	[STEP_IDENTIFIER_NAME.MEDIA]: {
		component: Media,
		preload: preloadMediaStep,
	},
	[STEP_IDENTIFIER_NAME.PHONE_COLLECTION]: {
		component: PhoneCollection,
		preload: preloadPhoneCollectionStep,
	},
	[STEP_IDENTIFIER_NAME.PUBLISH]: {
		component: Publish,
		preload: preloadPublishStep,
	},
	[STEP_IDENTIFIER_NAME.REACH]: {
		component: Reach,
		preload: preloadReachStep,
	},
};
